<template>
  <c-box
    v-if="disabled"
    fontSize="lg"
    pl="3xl"
    pr="3xl"
    pt="sm"
    pb="sm"
    borderRadius="full"
    :background="currentTab === tab ? 'brand.purple' : 'transparent'"
    :color="currentTab === tab ? 'white' : 'black'"
    text-overflow="ellipsis"
  >
    <slot />
  </c-box>
  <router-link v-else :to="{ path, query: { tab } }" :replace="true">
    <c-box
      fontSize="lg"
      pl="3xl"
      pr="3xl"
      pt="sm"
      pb="sm"
      borderRadius="full"
      :background="currentTab === tab ? 'brand.purple' : 'transparent'"
      :color="currentTab === tab ? 'white' : 'black'"
    >
      <slot />
    </c-box>
  </router-link>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { CBox } from "@chakra-ui/vue";

export default defineComponent({
  name: "Tab",
  components: {
    CBox,
  },
  props: {
    path: {
      type: String,
      required: true,
    },
    tab: {
      type: String,
      required: true,
    },
    currentTab: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    replace: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
